import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import http from "../lib/http";

export default function EditDealerPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    name: '',
    address: '',
    contact: '',
    password: "",
    category: '',
    gstNo: '',
    pan: '',
    aadhar: '',
    locationName: '',
    image: '',
  });

  const [imageFile, setImageFile] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Fetch dealer data by ID
    http.get(`/api/dealers/${id}`)
      .then(res => {
        const dealer = res.data;
        setFormData({
          name: dealer.name || '',
          address: dealer.address || '',
          contact: dealer.contact || '',
          password: dealer.password || '',
          category: dealer.category || '',
          gstNo: dealer.gstNo || '',
          pan: dealer.pan || '',
          aadhar: dealer.aadhar || '',
          locationName: dealer.locationName || '',
          image: dealer.image || '',
        });
      })
      .catch(err => console.error('Error fetching dealer:', err));
  }, [id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    setImageFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const payload = new FormData();
      Object.entries(formData).forEach(([key, value]) => {
        payload.append(key, value);
      });
      if (imageFile) {
        payload.append('image', imageFile);
      }

      await http.put(`/api/dealers/${id}`, payload);
      alert('Dealer updated successfully!');
      navigate('/admin/dealers');
    } catch (err) {
      console.error('Error updating dealer:', err);
      alert('Failed to update dealer');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-5">
      <h2>Edit Dealer</h2>
      <form onSubmit={handleSubmit} encType="multipart/form-data">
        <div className="row">
          <div className="col-md-6 mb-3">
            <label>Name</label>
            <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
          </div>
          <div className="col-md-6 mb-3">
            <label>Category</label>
            <input type="text" name="category" className="form-control" value={formData.category} onChange={handleChange} required />
          </div>
          <div className="col-md-6 mb-3">
            <label>Contact</label>
            <input type="text" name="contact" className="form-control" value={formData.contact} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
          <label>Password</label>

          <input
            type="password"
            name="password"
            className="form-control"
            value={formData.password}
            onChange={handleChange}
          />
        </div>
          <div className="col-md-6 mb-3">
            <label>Address</label>
            <input type="text" name="address" className="form-control" value={formData.address} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label>Location Name</label>
            <input type="text" name="locationName" className="form-control" value={formData.locationName} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label>GST No</label>
            <input type="text" name="gstNo" className="form-control" value={formData.gstNo} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label>PAN</label>
            <input type="text" name="pan" className="form-control" value={formData.pan} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label>Aadhar</label>
            <input type="text" name="aadhar" className="form-control" value={formData.aadhar} onChange={handleChange} />
          </div>
          <div className="col-md-6 mb-3">
            <label>Upload New Image</label>
            <input type="file" className="form-control" onChange={handleImageChange} />
          </div>
          {formData.image && (
            <div className="col-md-6 mb-3">
              <label>Current Image</label><br />
              <img src={formData.image} alt="dealer" style={{ width: '120px', height: '80px', objectFit: 'cover', border: '1px solid #ccc' }} />
            </div>
          )}
        </div>
        <button
            type="button"
            className="btn btn-sm btn-secondary mb-3"
            onClick={() => {
              http.get('/api/dealers/geocode', { params: { address: formData.address } })
                .then(res => setFormData(prev => ({
                  ...prev,
                  latitude: res.data.lat,
                  longitude: res.data.lng,
                  locationName: res.data.displayName || prev.locationName
                })))
                .catch(()=> alert('Address not found'));
            }}
          >
            Auto‑fetch lat/lng
          </button>
        <button type="submit" className="btn btn-primary" disabled={loading}>
          {loading ? 'Updating...' : 'Update Dealer'}
        </button>
      </form>
    </div>
  );
}
